export default __webpack_public_path__ + "static/media/grafema_martini-contest_05.eda96021.jpg";